import React from 'react';
import { TrendingUp, ShieldCheck, Zap } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { STATS } from '../data/constants';
import { HeroSearch } from './hero/HeroSearch';
import { HeroVisual } from './hero/HeroVisual';

const Hero = () => {
  const { t, lang } = useApp();
  const badges = [
    { id: 'escrow', icon: ShieldCheck, color: '#0F8B5C', label: t('hero.escrow') },
    { id: 'momo', icon: Zap, color: '#F2B441', label: t('hero.mobileMoney') },
    { id: 'countries', icon: TrendingUp, color: '#E8814A', label: t('hero.countries') },
  ];

  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-[#FAF7F2] to-white" data-testid="hero-section">
      <div className="absolute inset-0 pointer-events-none" aria-hidden>
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-[#0F8B5C]/8 blur-3xl" />
        <div className="absolute top-1/2 -left-24 w-96 h-96 rounded-full bg-[#F2B441]/12 blur-3xl" />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-20 md:pt-24 md:pb-28">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#0F8B5C]/10 text-[#0A6E47] text-xs font-semibold uppercase tracking-wider mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-[#0F8B5C] animate-pulse" /> {t('hero.eyebrow')}
            </span>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-black tracking-tight leading-[1.05] text-[#1A1A1A]" data-testid="hero-title">
              {t('hero.title')}{' '}
              <span className="relative inline-block">
                <span className="relative z-10 text-[#0F8B5C]">{t('hero.title.highlight')}</span>
                <svg className="absolute -bottom-2 left-0 w-full" viewBox="0 0 300 12" fill="none" aria-hidden><path d="M2 9C50 3 150 3 298 9" stroke="#F2B441" strokeWidth="4" strokeLinecap="round" /></svg>
              </span>
            </h1>
            <p className="mt-6 text-lg text-[#3F3A30] max-w-xl leading-relaxed">{t('hero.subtitle')}</p>
            <HeroSearch />
            <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-[#3F3A30]">
              {badges.map((b) => <span key={b.id} className="flex items-center gap-1.5"><b.icon className="w-4 h-4" style={{ color: b.color }} /> {b.label}</span>)}
            </div>
          </div>
          <HeroVisual />
        </div>
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 pt-10 border-t border-[#EFEAE0]">
          {STATS.map((s) => (
            <div key={s.id} data-testid={`stat-${s.id}`}>
              <div className="text-3xl md:text-4xl font-black text-[#1A1A1A] tracking-tight">{s.value}</div>
              <div className="text-sm text-[#7A7468] mt-1">{s.label[lang] || s.label.en}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
